/**
 * Componente ActionButtons - ConfereAI
 *
 * Botões de ação padronizados (Visualizar, Editar, Excluir).
 * Baseado no layout da página de Veículos.
 */

import React from 'react';
import './ActionButtons.css';

interface ActionButtonsProps {
  onView?: () => void;
  onEdit?: () => void;
  onDelete?: () => void;
  showView?: boolean;
  showEdit?: boolean;
  showDelete?: boolean;
  className?: string;
}

const ActionButtons: React.FC<ActionButtonsProps> = ({
  onView,
  onEdit,
  onDelete,
  showView = true,
  showEdit = true,
  showDelete = true,
  className = '',
}) => {
  return (
    <div className={`action-buttons ${className}`}>
      {showView && onView && (
        <button className="btn-view" onClick={onView} title="Visualizar">
          <i className="fas fa-eye"></i>
        </button>
      )}
      {showEdit && onEdit && (
        <button className="btn-edit" onClick={onEdit} title="Editar">
          <i className="fas fa-edit"></i>
        </button>
      )}
      {showDelete && onDelete && (
        <button className="btn-delete" onClick={onDelete} title="Excluir">
          <i className="fas fa-trash"></i>
        </button>
      )}
    </div>
  );
};

export default ActionButtons;
